/**
 * Direction A "Mycelium" (OD-6): a branching-hyphae mark plus the lowercase Space Grotesk wordmark.
 * The mark draws in currentColor (text-brand by default), so it follows the theme tokens. The
 * visible wordmark is lowercase by design; assistive tech hears the name as written, "HypheSync".
 * Kept identical in apps/web and apps/marketing.
 */
export function LogoMark({ className = "h-8 w-8 text-brand" }: { className?: string }) {
  return (
    <svg viewBox="0 0 40 40" fill="none" stroke="currentColor" strokeWidth={3} strokeLinecap="round" className={className} aria-hidden="true">
      <path d="M6 32 C14 26 16 18 20 8" />
      <path d="M20 8 C24 18 28 24 34 28" />
      <path d="M13 24 C18 26 24 25 28 22" />
      <circle cx="6" cy="32" r="3" fill="currentColor" />
      <circle cx="20" cy="8" r="3" fill="currentColor" />
      <circle cx="34" cy="28" r="3" fill="currentColor" />
    </svg>
  );
}

export function Logo({ size = "text-3xl" }: { size?: string }) {
  return (
    <span className={`inline-flex items-center gap-[0.3em] ${size}`}>
      <LogoMark className="h-[1em] w-[1em] text-brand" />
      <span className="sr-only">HypheSync</span>
      <span aria-hidden="true" className="font-display font-bold tracking-tight">
        hyphesync
      </span>
    </span>
  );
}
